import React from 'react';
import GpyComponent from './GpyComponent'
import {_GPY} from '../../../env.js'

class GpyScoreField extends GpyComponent {
  constructor(props) {
      super(props);

      this.state = {
            gpyComponentID: super.getId(),
            connected: false,
            score:0,
            min: this.props.min!==undefined?parseInt(this.props.min):0,
            max: this.props.max!==undefined?parseInt(this.props.max):100,
      };
    }

    onChangeValue(o){
      if ( o.score !== undefined ) {
            var s = parseInt(o.score,10);
            this.setState({score: s});
            var obj = {};
            obj[this.props.stateName] = s;
            super.sendGameState(obj);
      }
    }

    setScore(s){

      if(s < this.state.min) {
          s = this.state.min;
      }
      if(s > this.state.max) {
          s = this.state.max;
      }
      this.setState({score:s});

      var obj = {};
      obj[this.props.stateName] = JSON.stringify({score:s,value:s,gpyComponentID:this.state.gpyComponentID});
      obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
      obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
      super.sendGameState(obj);
    }

    componentWillMount(){
      if(this.props.scoreboard !== undefined ){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };
      if(this.props.scoreboard.state !== undefined && this.props.stateName !== undefined && this.props.scoreboard.state[this.props.stateName] !== undefined && this.props.scoreboard.state[this.props.stateName].score !== undefined) {
        this.setState({score : parseInt(this.props.scoreboard.state[this.props.stateName].score,10) });
      }
    }

    changeScore(e) {
        var s = _GPY.toNumber(e.target.value);
        this.setScore(s);
    }

    onData(key,data){
        if(data.gpyComponentID !== this.state.gpyComponentID) {
        this.setState({score : data.score});
      }
    }

  render() {
		return (
      <div className="row justify-content-center" style={{zIndex:100}}>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-4 text-center p-0"><input onFocus={(e)=>{e.target.select();}}  className="form-control" type="text" value={this.state.score} onChange={(e)=>{this.changeScore(e)}}></input></div>
      </div>
		)
  }
}
export default GpyScoreField;
